import { css } from "@emotion/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { trpcClient } from "../lib/trpc";
import { useOrganisation } from "../lib/organisation";
import { Router } from "../App";
import { slugify } from "../lib/slugify";
import { Button } from "../components/button";
import { appContainer } from "@/styles/shared";

const joinMain = css`
  max-width: 480px;
  margin: 0 auto;
  padding: 80px 24px;
  text-align: center;
`;

const joinTitle = css`
  font-family: var(--font-heading);
  font-size: var(--text-2xl);
  font-weight: 800;
  margin-bottom: 8px;
`;

const joinText = css`
  opacity: 0.6;
`;

const joinTextFaded = css`
  opacity: 0.4;
  margin-top: 16px;
`;

const joinLoadingText = css`
  font-size: 18px;
`;

const joinButton = css`
  margin-top: 24px;
`;

export function JoinOrganisationPage({ code }: { code: string }) {
  const { t } = useTranslation();
  const { addOrganisation } = useOrganisation();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [error, setError] = useState<string | null>(null);
  const [organisationName, setOrganisationName] = useState<string>("");

  useEffect(() => {
    trpcClient.acceptInvitation
      .mutate({ code })
      .then((result) => {
        setOrganisationName(result.organisationName);
        addOrganisation({ id: result.organisationId, name: result.organisationName });
        setStatus("success");
        setTimeout(() => {
          Router.push("Homepage", { orgSlug: slugify(result.organisationName) });
        }, 2000);
      })
      .catch((err) => {
        setStatus("error");
        setError(err instanceof Error ? err.message : t("invitation.error"));
      });
  }, [code]);

  return (
    <div css={appContainer}>
      <main css={joinMain}>
        {status === "loading" && <p css={joinLoadingText}>{t("invitation.joining")}</p>}
        {status === "success" && (
          <>
            <h2 css={joinTitle}>{t("invitation.success")}</h2>
            <p css={joinText}>
              {t("invitation.successDescription", { name: organisationName })}
            </p>
            <p css={joinTextFaded}>{t("invitation.redirecting")}</p>
          </>
        )}
        {status === "error" && (
          <>
            <h2 css={joinTitle}>{t("invitation.errorTitle")}</h2>
            <p css={joinText}>{error}</p>
            <Button variant="primary" css={joinButton} onClick={() => Router.push("Root")}>
              {t("invitation.backHome")}
            </Button>
          </>
        )}
      </main>
    </div>
  );
}
